var map = {
	"./add-square.svg": 4565,
	"./add.svg": 1401,
	"./alert-circle.svg": 8418,
	"./alert-triangle.svg": 9396,
	"./analytics-graph.svg": 9459,
	"./archive.svg": 6752,
	"./arrow-down-1.svg": 7755,
	"./arrow-down.svg": 572,
	"./arrow-left.svg": 8180,
	"./arrow-right.svg": 5009,
	"./arrow-up.svg": 7132,
	"./award-medal.svg": 1345,
	"./bin-1.svg": 4526,
	"./board-game-dice-1.svg": 2441,
	"./brain-head.svg": 8622,
	"./calendar.svg": 2384,
	"./camera.svg": 9449,
	"./check-1.svg": 6077,
	"./close.svg": 7283,
	"./cog-double.svg": 1326,
	"./cog.svg": 6581,
	"./color-brush-2.svg": 8300,
	"./common-file-empty.svg": 3444,
	"./console.svg": 8770,
	"./content-pen.svg": 5267,
	"./controls-play.svg": 3066,
	"./controls-rewind.svg": 3388,
	"./copy-paste.svg": 6957,
	"./cursor-choose.svg": 4485,
	"./cursor-target.svg": 5683,
	"./database-hand.svg": 4752,
	"./database-hierarchy.svg": 1533,
	"./database-settings.svg": 3684,
	"./designer-community-adobe.svg": 3772,
	"./dislike.svg": 1787,
	"./download-bottom.svg": 5601,
	"./e-learning-share.svg": 2861,
	"./earth-3.svg": 8552,
	"./email-action-at.svg": 459,
	"./expand-diagonal.svg": 6058,
	"./expand-horizontal-4.svg": 8922,
	"./expand-vertical-4.svg": 1954,
	"./file-code.svg": 9794,
	"./filter-1.svg": 1077,
	"./flip-left.svg": 8165,
	"./flip-right.svg": 1937,
	"./floppy-disk.svg": 2566,
	"./folder.svg": 7738,
	"./hammer-wench.svg": 1870,
	"./headphones-1.svg": 3037,
	"./house.svg": 232,
	"./human-resources-employee.svg": 7081,
	"./hyperlink.svg": 9479,
	"./image-below.svg": 932,
	"./image-left.svg": 4580,
	"./image-only.svg": 5168,
	"./image-right.svg": 2804,
	"./image-top.svg": 1943,
	"./information-circle.svg": 1727,
	"./keyboard-arrow-left.svg": 8133,
	"./keyboard-arrow-right.svg": 204,
	"./lab-flask-experiment.svg": 2299,
	"./layout-dashboard.svg": 7984,
	"./like.svg": 6277,
	"./list-numbers.svg": 7874,
	"./loading.svg": 6411,
	"./lock-5.svg": 1157,
	"./login-3.svg": 3856,
	"./login-keys.svg": 7638,
	"./logout-2.svg": 56,
	"./maps.svg": 9812,
	"./mhss/smiley-extreme-happy.svg": 2025,
	"./mhss/smiley-extreme-sad.svg": 501,
	"./mhss/smiley-happy.svg": 6441,
	"./mhss/smiley-neutral.svg": 1288,
	"./mhss/smiley-sad.svg": 6616,
	"./module-puzzle.svg": 5884,
	"./multiple-users-1.svg": 7756,
	"./navigation-left-circle-1_1.svg": 7250,
	"./navigation-menu.svg": 4194,
	"./navigation-right-circle-1.svg": 4362,
	"./notes-diary.svg": 4749,
	"./notes-tasks.svg": 2082,
	"./paragraph-image-right.svg": 2162,
	"./people-man-graduate.svg": 7837,
	"./picture-polaroid.svg": 4667,
	"./police-man-spy-2.svg": 6143,
	"./question-circle.svg": 510,
	"./rating-star-o.svg": 9559,
	"./rating-star.svg": 5096,
	"./reorder-down.svg": 3526,
	"./reorder-up.svg": 7519,
	"./road-sign-banned.svg": 628,
	"./school-building.svg": 1335,
	"./school-locker.svg": 8193,
	"./school-test-results.svg": 8532,
	"./server.svg": 5393,
	"./share.svg": 7503,
	"./shield-key.svg": 512,
	"./shipment-upload.svg": 8957,
	"./shop-barista.svg": 2394,
	"./shopping-basket-man.svg": 3659,
	"./single-man-actions-setting.svg": 9855,
	"./single-man-circle.svg": 9953,
	"./single-man.svg": 674,
	"./smiley-sad.svg": 7645,
	"./soccer-goal-net.svg": 6482,
	"./social-video-vimeo.svg": 9762,
	"./study-owl.svg": 9008,
	"./subtract-square.svg": 8253,
	"./tags.svg": 8571,
	"./text-only.svg": 433,
	"./time-clock-circle.svg": 682,
	"./tools-wench.svg": 7304,
	"./undo.svg": 854,
	"./upload-bottom.svg": 4872,
	"./video-game-magic-wand.svg": 8434,
	"./video-game-xbox-controller.svg": 8422,
	"./video-player-adjust.svg": 316,
	"./view-1.svg": 507,
	"./view-off.svg": 3125
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 619;